//RUTAS USUARIOS
export const urlGetUsers = "/api/users";
//--rutas x usuario
export const urlGetUserRoutes = "/api/user/routes";
//--rutas no asignadas x usuario
export const urlGetRoutesNotAsigned = "/api/user/routes/nota";
//--vincular/desvincular ruta a usuario
export const urlSwitchUserRoutes = "/api/user/routes/link";
